import React from 'react'

type props = {
  title?: string
}

const SPModuleTitle: React.FC<props> = (props) => {
  const style: React.CSSProperties = {
    position: 'relative',
    height: '24px',
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.88)',
    lineHeight: '24px',
    fontFamily: "PingFang SC",
    paddingLeft: '12px',
    fontWeight: 'bold',
  }

  const barStyle: React.CSSProperties = {
    position: 'absolute',
    width: '3px',
    height: '16px',
    left: 0,
    top: '4px',
    background: '#FF6400'
  }

  return <div style={style}>
    <div style={barStyle}></div>
    {props?.title}
  </div>
}

export default SPModuleTitle;
